import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./Dialog";

interface DialogConfirmationProps {
    children?: React.ReactNode;
    title: string;
    description: string;
    onConfirm: () => void;
    onCancel: () => void;
    onDismiss?: () => void;
    isOpen: boolean;
    confirmText?: string;
    cancelText?: string;
}

export default function DialogConfirmation({ children, title, description, onConfirm, onCancel, onDismiss, isOpen, confirmText, cancelText }: DialogConfirmationProps) {
    return (
        <Dialog open={isOpen} onOpenChange={(open) => {
            if (!open) (onDismiss || onCancel)();
        }}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                {children}
                <div className="mt-4 flex flex-grow flex-col justify-end gap-2 pb-2 sm:flex-row sm:place-items-end sm:justify-end">
                    <button className='btn-primary w-full bg-warning-red px-4 py-2 sm:w-fit sm:place-self-end' onClick={onConfirm}>
                        {confirmText || 'Delete'}
                    </button>
                    <button className='btn-secondary w-full px-4 py-2 sm:w-fit sm:place-self-end' onClick={onCancel}>
                        {cancelText || 'Cancel'}
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );
}